export default "__VITE_ASSET__6f452783__"